<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="formInline.type" placeholder="名片类型">
            <el-option v-for="(item,index) in typeList" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=""><el-input v-model="formInline.title" placeholder="请输入搜索内容"></el-input></el-form-item>
        <el-form-item><el-button icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>
    
    <!--添加产品-->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" v-auth="'/plus/card/cardlist/add'" @click="addClick">添加名片</el-button>
    </div>
    
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
             <el-table-column prop="card_id" label="名片id"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="nick_name" label="微信昵称">
              <template slot-scope="scope" v-if="scope.row.user">
                <div>{{scope.row.user.nickName}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="avatar_image" label="名片头像">
              <template slot-scope="scope">
                <div v-if="scope.row.avatarUrl">
                  <img :src="scope.row.avatarUrl" width="30px" height="30px" />
                </div>
                <div v-else-if="scope.row.user!=null">
                    <img :src="scope.row.user.avatarUrl" width="30px" height="30px" />
                </div>
              </template>
            </el-table-column>
            </el-table-column>
            <el-table-column prop="mobile" label="手机号">
              <template slot-scope="scope">
                <div v-if="scope.row.mobile">
                  {{scope.row.mobile}}
                </div>
                <div v-else-if="scope.row.user!=null">
                  {{scope.row.user.mobile}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="用户类型">
              <template slot-scope="scope">
                 <div class="orange" v-if="scope.row.type=='staff'">职工</div>
                <div class="orange" v-if="scope.row.type=='boss'">BOSS</div>
              </template>
            </el-table-column>
            <el-table-column prop="isdefault" label="是否默认">
              <template slot-scope="scope">
                <el-switch
                  @change="setCardDefault(scope.row)"
                  v-model="scope.row.isdefault"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="istop" label="是否置顶">
              <template slot-scope="scope">
                <el-switch
                  @change="setCardTop(scope.row)"
                  v-model="scope.row.istop"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </template>
            </el-table-column>

            <el-table-column prop="displayorder" label="排序">
              <template slot-scope="scope">
                <el-input type="number" @change="changeCardSort(scope.row)" v-model="scope.row.displayorder" ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" v-auth="'/plus/card/cardlist/edit'" type="text" size="small">编辑</el-button>
                <el-button @click="showCode(scope.row)" v-auth="'/plus/card/cardlist/showCode'" type="text" size="small">名片码</el-button>
                <el-button @click="deleteClick(scope.row)" v-auth="'/plus/card/cardlist/delete'" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
      <Qrcode v-if="isshow" :is_show="isshow"  :qrcode="qrcode"  @closeDialog="closeDialogLabelFunc"></Qrcode>
    </div>  
  </div>
</template>

<script>
import cardApi from '@/api/card.js';
import Qrcode from './code.vue';
export default {
  components: {
    Qrcode
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {},
      typeList: [],
      /* 二维码 */
      qrcode:'',
      isshow:false,
    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      cardApi.cardList(Params, true)
        .then(data => {
          self.loading = false;
          self.typeList = data.data.typeList;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加名片*/
    addClick() {
      this.$router.push('/plus/card/cardlist/add');
    },

    /*编辑名片*/
    editClick(row) {
      let card_id = row.card_id;
      this.$router.push({
        path: '/plus/card/cardlist/edit',
        query: {
          card_id: card_id
        }
      });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          cardApi.delCard(
            {
              card_id: row.card_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，名片删除成功',
                  type: 'success'
                });
                this.onSubmit();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    /* 
    *设置默认名片
    */
    setCardDefault(item){
      let self = this;
      let form = {
        'card_id':item.card_id,
        'isdefault':item.isdefault,
        'operation':'setdefault',
      }
      cardApi.editCard(form, true)
      .then(data => {
        self.loading = false;
        
        if (data.code == 1) {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          self.getTableList();
        } else {
          self.loading = false;
        }
      })
      .catch(error => {
        self.loading = false;
      });
    },
    /* 查看名片码 */
    showCode(item){
      let self = this;
      let form = {
        'card_id':item.card_id,
        'source':'wx'
      };
      cardApi.showCode(form, true)
      .then(data => {
        self.loading = false;
        
        if (data.code == 1) {
          self.isshow  = true;
          self.qrcode = data.data.qrcode
        } else {
          self.loading = false;
          self.$message({
            message: '二维码生成失败',
            type: 'error'
          });
        }
      })
      .catch(error => {
        self.loading = false;
      });
    },
      closeDialogLabelFunc(e) {
        let self = this;
        self.isshow = false;
  
      },

      /* 
    *置顶名片
    */
    setCardTop(item){
      let self = this;
      let form = {
        'card_id':item.card_id,
        'istop':item.istop,
        'operation':'settop',
      }
      cardApi.editCard(form, true)
      .then(data => {
        self.loading = false;
        
        if (data.code == 1) {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          self.getTableList();
        } else {
          self.loading = false;
        }
      })
      .catch(error => {
        self.loading = false;
      });
    },
    /* 
    *名片排序
    */
    changeCardSort(item){
      let self = this;
      let form = {
        'card_id':item.card_id,
        'displayorder':item.displayorder,
        'operation':'setsort',
      }
      cardApi.editCard(form, true)
      .then(data => {
        self.loading = false;
        
        if (data.code == 1) {
          self.$message({
            message: '设置成功',
            type: 'success'
          });
          self.getTableList();
        } else {
          self.loading = false;
        }
      })
      .catch(error => {
        self.loading = false;
      });
    }

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/card/cardlist/index.vue